<!-- This component renders a chart from Datawrapper, a third-party platform -->
<!-- Link to eng design doc: https://docs.google.com/document/d/1Dx8zk8qv5V_rrhHSmtFqsrrS51sdmcTvVzWKsX2V7d8 -->

<script lang="ts">
  import type { DatawrapperChart } from '$lib/sanity/schemas';
  import { captureException } from '@sentry/sveltekit';

  import { onMount } from 'svelte';
  interface Props {
    document: DatawrapperChart;
  }

  let { document }: Props = $props();

  const id = document.id;
  const scriptSrc = `https://datawrapper.dwcdn.net/${id}/embed.js`;

  onMount(() => {
    const chartContainerElement = window.document.getElementById(`datawrapper-vis-${id}`);
    if (!chartContainerElement) return;

    const script = window.document.createElement('script');
    script.src = scriptSrc;
    script.defer = true;
    script.setAttribute('data-target', `#datawrapper-vis-${id}`);

    script.onerror = () => {
      const error = new Error(`Failed to load Datawrapper chart ${scriptSrc}`);
      error.name = 'DatawrapperChartLoadError';

      captureException(error, {
        tags: { source: 'Datawrapper' },
        extra: { chartId: id, scriptSrc: scriptSrc }
      });
    };

    chartContainerElement.appendChild(script);
  });
</script>

<div style="min-height: 360px; width: 100%;" id={`datawrapper-vis-${id}`}></div>

<noscript>
  <img
    src={`https://datawrapper.dwcdn.net/${id}/full.png`}
    alt="JavaScript disabled. Rendering fallback chart."
  />
</noscript>
